module.exports = __webpack_public_path__ + "static/media/braille.2a996db7.jpg";